var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"h-5 w-5 rounded-sm",class:{
    'flex items-center justify-center bg-ds-button-icon': _vm.isChecked,
    'border border-ds-outline-primary': !_vm.isChecked,
  }},[(_vm.isChecked)?_c('inline-svg',{staticClass:"w-1/2 text-ds-background",attrs:{"src":"/img/icons/new/check-solid.svg"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }